import React, { useState, useEffect } from 'react';
import { ReactComponent as Sent } from '../../assets/images/sent.svg';
import { ReactComponent as Recived } from '../../assets/images/recived.svg';

function CmpsMsgStatus() {

  const [recived, setRecived] = useState(false);
  const [readed, setReaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRecived(true);
      const timer2 = setTimeout(() => {
        setReaded(true);
      }, 500);
    }, 1200);
    
  }, []);

  return (
    <>
      {(!recived && !readed) && <Sent className="status" />}
      {(recived && !readed) && <Recived className="status recived" />}
      {(recived && readed) && <Recived className="status recived readed" />}
    </>
  );
  
} 

export default CmpsMsgStatus;